import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ConsoleSection from './components/ConsoleSection';
import HowItWorksSection from './components/HowItWorksSection';
import PhilosophySection from './components/PhilosophySection';
import PlatformComingSoon from './components/PlatformComingSoon';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    // Check for saved theme preference or default to dark
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setDarkMode(true);
      document.documentElement.classList.add('dark');
    } else {
      setDarkMode(false);
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ConsoleSection />
        <HowItWorksSection />
        <PhilosophySection />
        <PlatformComingSoon />
        <CTASection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;